import { Message, Table } from 'semantic-ui-react';
import { LEVEL_NAME, fmtWhen, isRemoval, levelOf, periodTitle } from '../approvals.js';

/* The audit log for this report: every approval and every removal of an approval recorded for it, newest first - who, what, when and why. */
export default function ApprovalHistory({ rows }) {
  const sorted = [...rows].sort((a, b) => b.actioned_at.localeCompare(a.actioned_at) || String(b.approval_id).localeCompare(String(a.approval_id)));
  return (
    <section className="block" aria-labelledby="hist-heading">
      <h3 id="hist-heading" className="ui small header blockhead">Audit log – approvals recorded for this report</h3>
      {!sorted.length ? <Message info role="status">Nothing has been approved for this report yet.</Message> : (
        <Table celled compact unstackable>
          <caption className="visually-hidden">Approvals recorded for this report</caption>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell scope="col">Period</Table.HeaderCell>
              <Table.HeaderCell scope="col">Approval</Table.HeaderCell>
              <Table.HeaderCell scope="col">Action</Table.HeaderCell>
              <Table.HeaderCell scope="col">Person</Table.HeaderCell>
              <Table.HeaderCell scope="col">Date and time</Table.HeaderCell>
              <Table.HeaderCell scope="col">Comments</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sorted.map((a) => (
              <Table.Row key={a.approval_id} className={isRemoval(a) ? 'bad-differs' : undefined}>
                <Table.Cell>{periodTitle(a)}</Table.Cell>
                <Table.Cell>{LEVEL_NAME[levelOf(a)]}</Table.Cell>
                <Table.Cell>{isRemoval(a) ? 'Approval removed' : 'Approved'}</Table.Cell>
                <Table.Cell>{a.actioned_by_name}</Table.Cell>
                <Table.Cell><time dateTime={a.actioned_at}>{fmtWhen(a.actioned_at)}</time></Table.Cell>
                <Table.Cell>{a.comments || ''}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </section>
  );
}
